export const updateUser = user => ({
  type: 'UPDATE_USER',
  payload: user,
});
